import { TNotification } from '@/types/Notification.types';
// import { getNotifications } from '@/services/api/requests/notifications';
import queryKeys from '@/constants/queryKeys';
import { getNotifications } from '@/services/api/requests/notifications';
import { useInfinitePagination } from '../useInfinitePagination';

const useGetInfiniteNotifications = ({ enabled }: { enabled: boolean }) => {
  return useInfinitePagination<TNotification[]>({
    query: getNotifications,
    queryKey: [queryKeys.notifications.infinite],
    enabled,
  });
};

export default useGetInfiniteNotifications;
